import { render } from "./ExtSubscribeButton.vue?vue&type=template&id=98be3636&scoped=true"
import script from "./ExtSubscribeButton.vue?vue&type=script&lang=js"
export * from "./ExtSubscribeButton.vue?vue&type=script&lang=js"

import "./ExtSubscribeButton.vue?vue&type=style&index=0&id=98be3636&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98be3636"]])

export default __exports__